import { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import EditStudentEditControl from './EditStudentEditControl';
import PrimaryButton from '../../components/PrimaryButton/PrimaryButton';
import TextButton from '../../components/TextButton/TextButton';
import { parseFullName } from 'parse-full-name';
import { isUserHasKey } from '../../GlobalFunctions';
import { StudentProxyType } from '../../../peekapak-types/DataProtocolTypes';
import styles from './EditStudentModal.module.scss';
import studentStyles from '../../SCSS/Students.module.scss';

type Props = {
  student: StudentProxyType | { sid: string; userId: string };
  readingLevels: string[];
};

export class EditStudentModal extends Component<Props> {
  constructor(props: Props) {
    super(props);

    this.state = {
      student: undefined,
    };

    this.handleOnDone = this.handleOnDone.bind(this);
    this.handleOnSubmit = this.handleOnSubmit.bind(this);
    this.handleOnHide = this.handleOnHide.bind(this);
  }

  handleOnDone(newName) {
    this.handleOnSubmit(newName);
  }

  handleOnHide() {
    this.props.onHide();
  }

  handleOnSubmit(values: { name: string; readingLevel: number }) {
    const { name, readingLevel } = values;
    const newStudentObject = { ...this.state.student };
    if (name) {
      const parsedName = parseFullName(name);
      if (!parsedName.first.length && parsedName.last.length) {
        newStudentObject.firstName = parsedName.last;
        delete newStudentObject.lastName;
      } else if (parsedName.first.length && parsedName.last.length) {
        newStudentObject.firstName = parsedName.first;
        newStudentObject.lastName = parsedName.last;
      } else if (parsedName.first.length) {
        newStudentObject.firstName = parsedName.first;
      }
      if (parsedName.middle.length) {
        newStudentObject.middleName = parsedName.middle;
      } else {
        delete newStudentObject.middleName;
      }
    }
    if (readingLevel) {
      newStudentObject.readingLevel = readingLevel;
    }
    this.setState({
      student: newStudentObject,
    });
    this.props.onReplaceStudent(this.props.indexOfStudentUnderEdit, this.state.student);
    this.handleOnHide();
  }

  UNSAFE_componentWillReceiveProps(nextProps: Props) {
    if (
      this.state.student === undefined ||
      nextProps.student.sid !== this.state.student.sid ||
      nextProps.student.userId !== this.state.student.userId
    ) {
      this.setState({
        student: nextProps.student,
      });
    }
  }

  render() {
    return isUserHasKey('KEY_MYPEEKAVILLE_LESSONS') ? (
      <Modal
        dialogClassName={`ModalDialog ${styles.editStudentsModal}`}
        onHide={this.handleOnHide}
        show={this.props.show}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <p className={studentStyles.ModalDialogHeader}>Edit Student</p>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            <EditStudentEditControl
              onSubmit={this.handleOnSubmit}
              student={this.state.student}
              readingLevels={this.props.readingLevels}
            />
          </div>
        </Modal.Body>
        <Modal.Footer className={studentStyles.ModalDialogFooter}>
          <TextButton uppercase grey bold underlineHover onClick={this.handleOnHide}>
            Or Cancel
          </TextButton>
        </Modal.Footer>
      </Modal>
    ) : (
      <Modal
        dialogClassName={`ModalDialog ${styles.editStudentsModal}`}
        onHide={this.handleOnHide}
        show={this.props.show}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <p className={studentStyles.ModalDialogHeader}>Edit Student</p>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            <EditStudentEditControl onSubmit={this.handleOnSubmit} student={this.props.student} />
          </div>
        </Modal.Body>
        <Modal.Footer className={studentStyles.ModalDialogFooter}>
          <form>
            <div className={studentStyles.ModalDialogFooter}>
              <PrimaryButton onClick={this.handleOnDone}>Done Editing Student</PrimaryButton>
            </div>
          </form>
          <TextButton uppercase grey bold underlineHover onClick={this.handleOnHide}>
            Or Cancel
          </TextButton>
        </Modal.Footer>
      </Modal>
    );
  }
}

EditStudentModal.propTypes = {
  indexOfStudentUnderEdit: PropTypes.number,
  onHide: PropTypes.func.isRequired,
  onReplaceStudent: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
  student: PropTypes.shape({
    firstName: PropTypes.string,
    sid: PropTypes.string,
    userId: PropTypes.string,
  }),
};
